import type { IconName } from '@/components/ui/Icon';
import { type Permission, PERMISSIONS } from '@/constants/permissions';
import { type Route, ROUTES } from '@/constants/routes';

export interface NavItem {
  label: string;
  to: Route;
  icon: IconName;
  /** Shown only to users holding it. Leave out for screens every staff account has. */
  permission?: Permission;
}

export interface NavGroup {
  label: string;
  items: readonly NavItem[];
}

/** The staff sidebar. Items are filtered by permission, never by role name. */
export const STAFF_NAV: readonly NavGroup[] = [
  {
    label: 'Overview',
    items: [{ label: 'Dashboard', to: ROUTES.DASHBOARD, icon: 'dashboard' }],
  },
  {
    label: 'Front desk',
    items: [
      {
        label: 'Members',
        to: ROUTES.MEMBERS,
        icon: 'members',
        permission: PERMISSIONS.MEMBERS_READ,
      },
      {
        label: 'Enquiries',
        to: ROUTES.ENQUIRIES,
        icon: 'enquiry',
        permission: PERMISSIONS.PROSPECTS_READ,
      },
      {
        label: 'Bills',
        to: ROUTES.INVOICES,
        icon: 'card',
        permission: PERMISSIONS.INVOICES_READ,
      },
      {
        label: 'Attendance',
        to: ROUTES.ATTENDANCE,
        icon: 'clock',
        permission: PERMISSIONS.ATTENDANCE_READ,
      },
    ],
  },
  {
    label: 'Gym setup',
    items: [
      {
        label: 'Packages',
        to: ROUTES.PACKAGES,
        icon: 'package',
        permission: PERMISSIONS.PACKAGES_READ,
      },
      // Staff and Roles are hidden from the menu for now (the owner's call, 4 October). The
      // screens still work at their URLs; put these two lines back to show them again:
      // { label: 'Staff', to: ROUTES.STAFF, icon: 'staff', permission: PERMISSIONS.USERS_MANAGE },
      // { label: 'Roles', to: ROUTES.ROLES, icon: 'shield', permission: PERMISSIONS.ROLES_MANAGE },
    ],
  },
];
